
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"10","viewBox":"0 0 18 10"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M18 6h-2V4h2v2zm0 4h-2V8h2v2zm0-8h-2V0h2v2zm-4 4H0V4h14v2zm0 4H0V8h14v2zm0-10v2H0V0h14z"}})])
          )
        }
      }
    